import BaseTable from 'components/Tables/BaseTable';
import { useTours } from 'features/Responder/features/Tours';
import { useEffect, useMemo, useState } from 'react';
import { timeAgo } from '../utils/personnelListUtils';

const Table = ({ personnel }) => {
  const { setCenter } = useTours();
  const [currentTime, setCurrentTime] = useState();

  const handleRowClick = (person) => {
    if (person.locations && person.locations.length > 0) {
      const latest = person.locations[person.locations.length - 1];
      if (latest?.lat != null && latest?.lng != null) {
        const targetZoom = 16;
        setCenter([latest.lat, latest.lng, targetZoom]);
      }
    }
  };

  // Transform personnel data for BaseTable
  const rows = useMemo(
    () =>
      Object.values(personnel).map((person) => ({
        id: person.userId,
        userId: person.userId,
        name: person.name,
        clockedIn: person.clockedIn,
        clockInTime: person.clockInTime,
        clockOutTime: person.clockOutTime,
        locations: person.locations,
      })),
    [personnel],
  );

const columns = useMemo(
  () => [
    {
      header: 'ID',
      accessorKey: 'userId',
      size: 70,
      Cell: ({ cell }) => (
        <div className="text-white fs-6">#{cell.getValue()}</div>
      ),
    },
    {
      header: 'Name',
      accessorKey: 'name',
      size: 200,
      Cell: ({ cell }) => (
        <p className="text-white fs-6 text-truncate">
          {cell.getValue()}
        </p>
      ),
    },
    {
      header: 'Status',
      accessorKey: 'clockedIn',
      size: 120,
      Cell: ({ cell }) => {
        const isOnline = cell.getValue();
        return (
          <p className={`badge ${isOnline ? 'bg-success' : 'bg-secondary'} text-center`}>
            {isOnline ? 'Clocked In' : 'Offline'}
          </p>
        );
      },
    },
    {
      header: 'Since',
      accessorKey: 'clockInTime',
      size: 140,
      Cell: ({ row, cell }) => {
        const person = row.original;
        let timestamp;

        if (!person.clockedIn && person.clockOutTime) {
          timestamp = person.clockOutTime;
        } else if (person.locations?.length > 0) {
          timestamp = person.locations.at(-1).timestamp;
        } else {
          timestamp = cell.getValue();
        }

        return (
          <div className="text-white text-nowrap fs-6">
            {timeAgo(timestamp, currentTime)}
          </div>
        );
      },
    },
  ],
  [currentTime],
);

  // Update current time every minute to refresh "time ago" calculations
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <BaseTable
      rows={rows}
      columns={columns}
      onRowClick={handleRowClick}
      customStyles={{
        cell: {
          borderBottom: '1px solid #56577A',
          cursor: 'pointer',
          color: 'white',
        },
        row: {
          '&:hover': {
            backgroundColor: '#2C373B',
          },
        },
      }}
    />
  );
};

export default Table;
